import { z } from "zod";

import { isoDate } from "./iso-date-schema";

export const viaChannelEnum = z.enum(["EMAIL", "WEB", "MOBILE"]);
export const typeEnum = z.enum(["PHOTO", "VIDEO", "FILE"]);

export const attachmentSchema = z.object({
  id: z.string().length(24),
  contentUri: z.string(),
  thumbnailUri: z.string().nullable(),
  fileName: z.string(),
  fileSize: z.number().int().default(0),
  viaChannel: viaChannelEnum,
  type: typeEnum,
  uploaded: z.boolean(),
  userCreatedId: z.string().nullable(),
  createdAt: isoDate,
  updatedAt: isoDate,
});
